import { Reveal } from "@/components/site/Reveal";

const groups = [
  {
    city: "Paderno Dugnano",
    photos: ["/collaboratori/arese-1.jpg", "/collaboratori/arese-2.jpg", "/collaboratori/paderno-3.jpg"],
  },
  {
    city: "Arese",
    photos: ["/collaboratori/paderno-1.jpg", "/collaboratori/paderno-2.webp"],
  },
  {
    city: "San Donato Milanese",
    photos: ["/collaboratori/sandonato-1.jpg", "/collaboratori/sandonato-2.jpg"],
  },
  {
    city: "Seveso",
    photos: ["/collaboratori/seveso-1.jpg"],
  },
  {
    city: "Palermo",
    photos: ["/collaboratori/palermo-1.jpg", "/collaboratori/palermo-2.jpg"],
  },
];

export const Collaboratori = () => (
  <section id="collaboratori" className="py-20 md:py-28" data-testid="collaboratori-section">
    <div className="max-w-7xl mx-auto px-5 md:px-10">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#385244]">Il team negli studi</p>
        <h2 className="mt-3 font-serif-display font-light text-4xl md:text-5xl text-[#15201A]">
          Collaborano <em className="italic text-[#385244]">con noi</em> 😊
        </h2>
      </Reveal>
      {groups.map((g, gi) => (
        <div key={g.city} className="mt-12" data-testid={`collaboratori-${g.city.toLowerCase().replace(/\s+/g, "-")}`}>
          <Reveal delay={gi * 0.05}>
            <h3 className="font-serif-display font-light text-2xl md:text-3xl text-[#15201A] border-l-4 border-[#C98E6E] pl-4">
              {g.city}
            </h3>
          </Reveal>
          <div className="mt-6 grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
            {g.photos.map((src, i) => {
              const dot = src.lastIndexOf(".");
              const srcset = `${src.slice(0, dot)}-320${src.slice(dot)} 320w, ${src.slice(0, dot)}-480${src.slice(dot)} 480w, ${src} 800w`;
              return (
              <Reveal key={src} delay={i * 0.08}>
                <div className="rounded-[24px] overflow-hidden bg-white border border-border aspect-[4/5]">
                  <img
                    src={src}
                    srcSet={srcset}
                    sizes="(max-width: 768px) 50vw, 33vw"
                    alt={`Collaboratrice studio di ${g.city}`}
                    loading="lazy"
                    decoding="async"
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                    data-testid={`collaboratori-photo-${g.city.toLowerCase().replace(/\s+/g, "-")}-${i + 1}`}
                  />
                </div>
              </Reveal>
            );})}
          </div>
        </div>
      ))}
    </div>
  </section>
);
